var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ExpandIcon } from "../Icons";
import { typographyStyles } from "../Typography";
import { Accordion as BaseAccordion } from '@base-ui-components/react';
import { colors } from "../../tokens/color";
import { fontWeights } from "../../tokens/typography";
import { breakpoints } from "../../tokens/size";
const classes = {
    trigger: {
        cursor: 'pointer',
        background: 'none',
        outline: 'none',
        border: 'none',
        padding: '1.2rem 1.6rem',
        borderRadius: '4px',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '10px',
        transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&:hover': {
            backgroundColor: colors.background.light,
        },
        [`@media (max-width: ${breakpoints.sm})`]: {
            padding: '0.8rem 1.6rem',
        },
    },
    content: Object.assign(Object.assign({}, typographyStyles.header5), { color: colors.text.activeSecondary, fontWeight: fontWeights.medium, textAlign: 'left' }),
    header: {
        margin: 0,
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '[data-panel-open] > &': {
            transform: 'rotate(180deg)',
        },
    },
};
/**
 * Toggles the expand/collapse state of the accordion. It is nested inside of a heading.
 *
 * @example
 * <AccordionTrigger>Click me</AccordionTrigger>
 *
 */
export function AccordionTrigger(_a) {
    var { headingLevel = 'h3', hideIcon = false, children } = _a, props = __rest(_a, ["headingLevel", "hideIcon", "children"]);
    const HeadingTag = headingLevel;
    return (_jsx(BaseAccordion.Header, { render: _jsx(HeadingTag, {}), css: classes.header, children: _jsxs(BaseAccordion.Trigger, Object.assign({ css: classes.trigger }, props, { children: [_jsx("div", { css: classes.content, children: children }), !hideIcon ? (_jsx("span", { css: classes.icon, children: _jsx(ExpandIcon, { width: 20, height: 20, color: colors.text.activeSecondary }) })) : null] })) }));
}
